import React, { Component } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import "./css/DataVisualizationFeature.css"

export default class DataVisualizationFeature extends Component {
        render() {
                return (
                        <Container style={{ width: "75%" }} className="p-5" id="data-visualization">
                                <Row>
                                        <Col lg={6} md={12}>
                                                <img src="images/HomePage/visualization.png" className="about-illustration" alt="data-svg-illustration"></img>
                                        </Col>
                                        <Col lg={6} md={12} className="text-center" id="data-visualization-text">
                                                <div className="info-heading"><span className="text-primary">DATA V</span>ISUALIZATION</div>
                                                <p className="info-text-normal" >We provide the visualization tools which will help you understand the data with the different types of graphs</p>
                                                <Container>
                                                        <Row>
                                                                <div className="col-4 p-3">
                                                                        <img className="graph-icon" src="images/HomePage/pie-chart.png" alt="pie_chart_image"></img>
                                                                </div>
                                                                <div className="col-4 p-3">
                                                                        <img className="graph-icon" src="images/HomePage/area-chart.png" alt="pie_chart_image"></img>
                                                                </div>
                                                                <div className="col-4 p-3">
                                                                        <img className="graph-icon" src="images/HomePage/bar-chart.png" alt="pie_chart_image"></img>
                                                                </div>
                                                                <div className="col-4 p-3">
                                                                        <img className="graph-icon" src="images/HomePage/stocks.png" alt="pie_chart_image"></img>
                                                                </div>
                                                                <div className="col-4 p-3">
                                                                        <img className="graph-icon" src="images/HomePage/scatter-plot.png" alt="pie_chart_image"></img>
                                                                </div>
                                                                <div className="col-4 p-3">
                                                                        <img className="graph-icon" src="images/HomePage/histogram.png" alt="pie_chart_image"></img>
                                                                </div>
                                                        </Row>
                                                </Container>
                                        </Col>
                                </Row>
                        </Container>
                )
        }
}
